export default function ConversorHours({ minutes }) {

    const horas = Math.floor(minutes/ 60);
    const min = minutes % 60;
    const textoHoras = (`${horas}`);
    const textoMinutos = (`${min}`);

    if (minutes <= 59) {
        return `${textoMinutos}min`;
    } else if (minutes == 60) {
        return `${textoHoras }h`;
    } else if (minutes >= 61) {
        return `${textoHoras }h, ${textoMinutos}min`;
    }

}